<template>
    <b-container>
        <b-row>
            <b-col>
                <h2 class="m-0 h1 text-uppercase">
                    {{ $t('parcelas.rellena_datos') }}
                </h2>
                <h3 class="subtitle h3 light mb-3">{{ $t('parcelas.rellenar_informacion') }}:</h3>
            </b-col>
            <b-col cols="12" class="mt-3">
                <transition name="fade" mode="out-in">
                    <DatosCompradorParcelas 
                        :datosParcelas="datosParcelas"
                        :datosComprador="datosComprador"
                        @updateDatosComprador="datos => $emit('updateDatosComprador', datos)"
                        @cambiarAsiento="$emit('cambiarAsiento')"
                        @terminado="(jet_id, formulario) => { $emit('terminado', jet_id, formulario) }"
                    />  
                </transition>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import DatosCompradorParcelas from './DatosCompradorParcelas';

    export default {
        props: {
            datosParcelas: {
                type: Array,
                required: true
            },
            datosComprador : {
                type: Object,
                required: false,
            }
        },
        components: {
            DatosCompradorParcelas
        }
    }
</script>